/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Company } from './Company'
import type { Professional } from './Professional'
import type { Users_Permissions_User } from './Users_Permissions_User'
import type { Vacancy } from './Vacancy'
export type Matching = {
  id?: number
  company?: Company
  vacancy?: Vacancy
  professional?: Professional
  score?: number
  type?: Matching.type
  identifier: string
  createdAt?: string
  updatedAt?: string
  createdBy?: Users_Permissions_User
  updatedBy?: Users_Permissions_User
}
export namespace Matching {
  export enum type {
    TAGS = 'tags',
    CULTURE = 'culture',
    PERSONALITY = 'personality',
    COGNITIVE = 'cognitive',
    MOTIVATIONS = 'motivations',
    TOTAL = 'total',
  }
}
